import { itemsService } from '../services'

const getForms = (id) => {
	return new Promise(resolve => {
		itemsService.getForms(id)
			.then(response => resolve({ success: true, data: response.data }))
	})
}
export default getForms